import { Component, OnInit, ViewChild, ElementRef, Input } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  AbstractControl,
} from "@angular/forms";
import { Entity, Plan } from "../../../model/entity";
import { map, startWith } from "rxjs/operators";
import { Observable, BehaviorSubject } from "rxjs";
import { WizardStep } from "../../../wizard/wizard.component";
import { FilterCompleteService } from "../../../filter-complete/filter-complete";
import { ValidateAutoCompleteSelect } from "../../../validators/autocomplete-select.validator";
import { ReservationWizardService } from "../../../services/wizard/reservation/reservation.wizard.service";
import {
  PracticeRegionReservation,
  PracticeRegionSearchReservation,
} from "../../../model/practice-region-reservation";
import { SetSuppliesReservation } from "../../../model/set-supplies-reservation";
import {
  ServiceReservation,
  ServiceReservationInfo,
} from "../../../model/service-reservation";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { FilterService } from "../../../services/filter.service";
import { MatDialog } from "@angular/material";
import { PracticeRegionPreparationDialogComponent } from "../../dialogs/practice-region-preparation/practice-region-preparation-dialog.component";
import { reservationSetSupplieValidator } from "../../../validators/reservation-set-supplie.validator";
import { IntegratedAdmissionService } from "src/app/services/integrated-admission/integrated-admission.service";
import { IntegratedOrderConf } from "src/app/model/integrated-admission/integrated-order-conf";

@Component({
  selector: "app-reservation-practice-component",
  templateUrl: "./reservation-practice.component.html",
  styleUrls: ["./reservation-practice.component.css"],
})
export class ReservationPracticeComponent implements OnInit, WizardStep {
  loadingReservationService = false;
  addingPractice: boolean;
  isInit: boolean;
  loading = false;
  loadingPracticesRegion = false;
  public reservationPracticeFormGroup: FormGroup;
  entities: Entity[];
  plans: Plan[];
  practicesRegionSearch: PracticeRegionSearchReservation[];
  plan: Plan;
  conf: IntegratedOrderConf;

  selectedEntity: Entity;

  setsSuppliesReservationAux: SetSuppliesReservation[] = [];
  practicesRegionReservationAux: PracticeRegionReservation[] = [];

  displayPracticesColumns = ["Name", "Quantity", "buttons"];
  practicesDataSource = new BehaviorSubject<AbstractControl[]>([]);

  displayAditionalsColumns = ["Select", "Name", "Quantity"];
  aditionalsDataSource = new BehaviorSubject<AbstractControl[]>([]);

  displaySetSuppliesColumns = ["Select", "Name", "Quantity"];
  setSuppliesDataSource = new BehaviorSubject<AbstractControl[]>([]);

  filterCompleteEntities: FilterCompleteService<Entity>;
  filterCompletePlans: FilterCompleteService<Plan>;
  filterCompletePractices: Observable<PracticeRegionSearchReservation[]>;
  @ViewChild("entity", { static: false }) entity: ElementRef;
  @ViewChild("practiceRegionReservation", { static: false })
  practiceRegionReservation: ElementRef;
  @Input("ocultarPreparacion") ocultarPreparacion: boolean;
  @Input("ocultarCombo") ocultarCombo: boolean;

  constructor(
    private notificationToastService: NotificationToastService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private integratedAdmissionService: IntegratedAdmissionService,
    public reservationWizardService: ReservationWizardService,
  ) {
    this.reservationPracticeFormGroup = this.formBuilder.group({
      Index: [0],
      Center: [""],
      Entity: ["", [Validators.required, ValidateAutoCompleteSelect]],
      Plan: ["", [Validators.required, ValidateAutoCompleteSelect]],
      PracticeRegionReservation: [""],
      DateOrder: [""],
      Diagnostic: [""],
      ReferringPhysician: [""],
      CredentialNumber: [""],
      Observation: [""],
      ReservationSlot: [""],
      IsInternation: [reservationWizardService.getIsInternation()],
      PracticesRegionReservation: this.formBuilder.array([]),
      PracticesRegionAditionalReservation: this.formBuilder.array([]),
      SetSuppliesReservation: this.formBuilder.array([]),
    });

    this.filterCompleteEntities = new FilterCompleteService<Entity>(
      [],
      this.reservationPracticeFormGroup.controls.Entity,
    );
    this.filterCompletePlans = new FilterCompleteService<Plan>(
      [],
      this.reservationPracticeFormGroup.controls.Plan,
    );
    this.reservationPracticeFormGroup.valueChanges.subscribe(() => {
      this.reservationWizardService.clearQuestionsAndSlotReservation();
    });
  }

  get valid(): boolean {
    return this.completed;
  }
  get getAllServiceReservations(): ServiceReservation[] {
    return this.reservationWizardService.getAllServiceReservations;
  }
  get setSuppliesReservation() {
    return <FormArray>(
      this.reservationPracticeFormGroup.get("SetSuppliesReservation")
    );
  }
  get practicesRegionAditionalReservation() {
    return <FormArray>(
      this.reservationPracticeFormGroup.get(
        "PracticesRegionAditionalReservation",
      )
    );
  }
  get practicesRegionReservation() {
    return <FormArray>(
      this.reservationPracticeFormGroup.get("PracticesRegionReservation")
    );
  }
  get filteredCentersOptions() {
    return [];
  }
  get filteredPlansOptions() {
    return this.filterCompletePlans
      ? this.filterCompletePlans.filteredOptions
      : [];
  }
  get filteredEntitiesOptions() {
    return this.filterCompleteEntities
      ? this.filterCompleteEntities.filteredOptions
      : [];
  }
  get f() {
    return this.reservationPracticeFormGroup.controls;
  }
  get completed(): boolean {
    return this.isValid();
  }

  private clearPlan() {
    this.reservationPracticeFormGroup.patchValue({ Plan: null });
    this.plans = [];
    this.filterCompletePlans = new FilterCompleteService<Plan>(
      [],
      this.reservationPracticeFormGroup.controls.Plan,
    );
    this.reservationWizardService.clearQuestionsAndSlotReservation();
  }

  private clearPractices() {
    this.reservationPracticeFormGroup.controls.PracticesRegionReservation =
      this.formBuilder.array([]);
    this.reservationPracticeFormGroup.controls.PracticesRegionAditionalReservation =
      this.formBuilder.array([]);
    this.reservationPracticeFormGroup.controls.SetSuppliesReservation =
      this.formBuilder.array([]);
    this.reservationPracticeFormGroup.patchValue({
      PracticeRegionReservation: null,
    });
    this.practicesRegionSearch = [];
    this.setFilterCompletePractices();
    this.reservationWizardService.clearQuestionsAndSlotReservation();
  }

  private getAddedPracticesRegionIds(
    excludeActualReservationPractices: boolean,
  ): number[] {
    const practicesIds: number[] = [];
    const practices = <PracticeRegionReservation[]>(
      this.practicesRegionReservation.value
    );

    if (practices && practices.length > 0) {
      practices.forEach((item: PracticeRegionReservation) => {
        practicesIds.push(item.PracticeRegion.Id);
      });
    }

    const actualServiceReservation = <ServiceReservation>(
      this.reservationPracticeFormGroup.value
    );
    if (this.reservationWizardService.getAllServiceReservations) {
      this.reservationWizardService.getAllServiceReservations.forEach(
        (serviceReservation) => {
          if (
            !excludeActualReservationPractices ||
            actualServiceReservation.Index !== serviceReservation.Index
          ) {
            practicesIds.push(
              serviceReservation.PracticesRegionReservation[0].PracticeRegion
                .Id,
            );
          }
        },
      );
    }

    return practicesIds;
  }

  filterPracticeRegionSearch(
    seachText?: string,
  ): PracticeRegionSearchReservation[] {
    return seachText
      ? this.practicesRegionSearch.filter(
          (option) =>
            option && this.coincideFilter(option, seachText.split(" ")),
        )
      : this.practicesRegionSearch
        ? this.practicesRegionSearch.slice()
        : [];
  }

  coincideFilter(
    practiceRegionSearchReservation: PracticeRegionSearchReservation,
    filters: string[],
  ): boolean {
    let response = true;
    filters.forEach((filter) => {
      if (
        filters.length === 1 &&
        practiceRegionSearchReservation.Code &&
        practiceRegionSearchReservation.Code === filter
      ) {
        response = true;
      } else if (
        response &&
        practiceRegionSearchReservation.SeachText.toLowerCase().indexOf(
          filter.toLowerCase(),
        ) < 0
      ) {
        response = false;
      }
    });

    return response;
  }

  displayPracticeRegionReservationFn(
    item?: PracticeRegionSearchReservation,
  ): string | undefined {
    return item ? item.PracticeRegionName : undefined;
  }

  displaySetSuppliesName(index: number): string {
    return this.setSuppliesReservation.controls[index].value.Name;
  }

  displayPracticeName(index: number): string {
    return this.practicesRegionReservation.controls[index].value.Name;
  }

  displayAditionalPracticeName(index: number): string {
    return this.practicesRegionAditionalReservation.controls[index].value.Name;
  }

  practiceRegionAditionalReservationCheckChange(index: number) {
    const select = <boolean>(
      this.practicesRegionAditionalReservation.getRawValue()[index].Select
    );
    const id = <number>(
      this.practicesRegionAditionalReservation.getRawValue()[index].Id
    );

    if (!select) {
      this.deleteSetSuppliesReservation(id);
      this.refreshPracticesAditionalAndSet();
    } else {
      this.setsSuppliesReservationAux
        .filter(
          (p: SetSuppliesReservation) => p.PrincipalPracticeRegionId === id,
        )
        .forEach((set: SetSuppliesReservation) => {
          this.addSetSuppliesReservation(set);
        });
    }

    this.reservationWizardService.clearQuestionsAndSlotReservation();
  }

  // agrego las los set de insumo al formulario, si no se encuentra cargado
  addSetSuppliesReservation(
    setSuppliesReservation: SetSuppliesReservation,
  ): void {
    // busco si el set de insumo se encuentra cargado
    const index = (<SetSuppliesReservation[]>(
      this.setSuppliesReservation.value
    )).findIndex((x) => x.Id === setSuppliesReservation.Id);

    if (
      index < 0 ||
      (setSuppliesReservation.Obligatory &&
        !this.setSuppliesReservation.controls[index].value.Obligatory)
    ) {
      if (index > -1) {
        this.setSuppliesReservation.removeAt(index);
      }
      const row = this.formBuilder.group(
        {
          PracticeRegionSetSuppliesId: [
            setSuppliesReservation.PracticeRegionSetSuppliesId,
          ],
          SetSupplies: [setSuppliesReservation.SetSupplies],
          Select: [
            {
              value: setSuppliesReservation.Select,
              disabled: setSuppliesReservation.Obligatory,
            },
          ],
          Id: [setSuppliesReservation.Id],
          AgreementPriceId: [setSuppliesReservation.AgreementPriceId],
          Name: [setSuppliesReservation.Name],
          PrincipalPracticeRegionId: [
            setSuppliesReservation.PrincipalPracticeRegionId,
          ],
          Obligatory: [setSuppliesReservation.Obligatory],
          ProlongedDuration: [setSuppliesReservation.ProlongedDuration],
          Quantity: [setSuppliesReservation.Quantity, [Validators.required]],
        },
        { validator: reservationSetSupplieValidator.bind(this) },
      );

      this.setSuppliesReservation.push(row);
      this.setSuppliesDataSource.next(this.setSuppliesReservation.controls);
    }
  }

  // agrego las practicas al formulario
  addPracticeRegionReservation(
    practiceRegionReservation: PracticeRegionReservation,
  ): void {
    // busco si la practica se encuentra cargada
    const index = (<PracticeRegionReservation[]>(
      this.practicesRegionReservation.getRawValue()
    )).findIndex(
      (x) =>
        x.PracticeRegion.Id === practiceRegionReservation.PracticeRegion.Id,
    );

    if (index < 0) {
      const row = this.formBuilder.group({
        Id: [practiceRegionReservation.Id],
        PracticeRegion: [practiceRegionReservation.PracticeRegion],
        ServiceColor: [practiceRegionReservation.ServiceColor],
        DiagnosticRequired: [practiceRegionReservation.DiagnosticRequired],
        ServiceId: [practiceRegionReservation.ServiceId],
        AgreementPriceId: [practiceRegionReservation.AgreementPriceId],
        AditionalId: [practiceRegionReservation.AditionalId],
        IsAditional: [practiceRegionReservation.IsAditional],
        PracticeId: [practiceRegionReservation.PracticeId],
        PrincipalPracticeRegionId: [
          practiceRegionReservation.PrincipalPracticeRegionId,
        ],
        ProlongedDuration: [practiceRegionReservation.ProlongedDuration],
        Name: [practiceRegionReservation.Name],
        Quantity: [practiceRegionReservation.Quantity, [Validators.required]],
      });

      this.practicesRegionReservation.push(row);
      this.practicesDataSource.next(this.practicesRegionReservation.controls);
    }
  }

  // agrego las practicas adicionales al formulario, si no se encuentra cargado
  addPracticeRegionAditionalReservation(
    practiceRegionReservation: PracticeRegionReservation,
  ): void {
    // busco si la practica se encuentra cargada
    let index = (<PracticeRegionReservation[]>(
      this.practicesRegionAditionalReservation.getRawValue()
    )).findIndex(
      (x) =>
        x.PracticeRegion.Id === practiceRegionReservation.PracticeRegion.Id,
    );

    if (index < 0) {
      const row = this.formBuilder.group({
        Select: [
          {
            value: practiceRegionReservation.Select,
            disabled: practiceRegionReservation.Obligatory,
          },
        ],
        Id: [practiceRegionReservation.Id],
        DiagnosticRequired: [practiceRegionReservation.DiagnosticRequired],
        ServiceColor: [practiceRegionReservation.ServiceColor],
        Obligatory: [practiceRegionReservation.Obligatory],
        PracticeRegion: [practiceRegionReservation.PracticeRegion],
        AgreementPriceId: [practiceRegionReservation.AgreementPriceId],
        AditionalId: [practiceRegionReservation.AditionalId],
        IsAditional: [practiceRegionReservation.IsAditional],
        PracticeId: [practiceRegionReservation.PracticeId],
        PrincipalPracticeRegionId: [
          practiceRegionReservation.PrincipalPracticeRegionId,
        ],
        ProlongedDuration: [practiceRegionReservation.ProlongedDuration],
        Name: [practiceRegionReservation.Name],
        Quantity: [practiceRegionReservation.Quantity, [Validators.required]],
      });

      this.practicesRegionAditionalReservation.push(row);
      this.aditionalsDataSource.next(
        this.practicesRegionAditionalReservation.controls,
      );
    }
  }

  deletePracticeRegionAditionalReservation(
    principalPracticeRegionId: number,
  ): void {
    let removeIndex = 0;
    while (removeIndex > -1) {
      removeIndex = this.practicesRegionAditionalReservation
        .getRawValue()
        .findIndex(
          (a) => a.PrincipalPracticeRegionId === principalPracticeRegionId,
        );
      if (removeIndex > -1) {
        // elimino los sets que le corresponden a esta adicional
        this.deleteSetSuppliesReservation(
          this.practicesRegionAditionalReservation.controls[removeIndex].value
            .Id,
        );
        this.practicesRegionAditionalReservation.removeAt(removeIndex);
        this.aditionalsDataSource.next(
          this.practicesRegionAditionalReservation.controls,
        );
      }
    }
  }

  deleteSetSuppliesReservation(principalPracticeRegionId: number): void {
    let removeIndex = 0;
    while (removeIndex > -1) {
      removeIndex = this.setSuppliesReservation
        .getRawValue()
        .findIndex(
          (a) => a.PrincipalPracticeRegionId === principalPracticeRegionId,
        );
      if (removeIndex > -1) {
        this.setSuppliesReservation.removeAt(removeIndex);
        this.setSuppliesDataSource.next(this.setSuppliesReservation.controls);
      }
    }
  }

  async activate() {
    setTimeout(() => this.setFocus(), 500);
  }

  isValid(): boolean {
    return (
      this.reservationPracticeFormGroup &&
      this.isValidSetSupplies() &&
      this.reservationPracticeFormGroup.valid &&
      (<PracticeRegionReservation[]>this.practicesRegionReservation.value)
        .length > 0
    );
  }

  isValidSetSupplies(): boolean {
    let isValid = true;
    this.setSuppliesReservation.controls.forEach((control) => {
      if (control.errors && control.errors.invalidAgreementPriceId) {
        isValid = false;
        this.notificationToastService.error(
          "No existe convenio para el set de insumo" + control.value.Name,
          "Reserva",
        );
      }
    });
    return isValid;
  }

  async onDeletePractice(index: number) {
    try {
      const principalPracticeRegionId =
        this.practicesRegionReservation.controls[index].value.Id;
      // elimino las adicionales y set que corresponden a la practica region
      this.deletePracticeRegionAditionalReservation(principalPracticeRegionId);
      this.deleteSetSuppliesReservation(principalPracticeRegionId);
      this.practicesRegionReservation.removeAt(index);
      this.practicesDataSource.next(this.practicesRegionReservation.controls);
      this.refreshPracticesAditionalAndSet();
      this.reservationWizardService.clearQuestionsAndSlotReservation();

      // si el servicio ya no tiene practicas, lo elimino
      if (this.practicesRegionReservation.controls.length === 0) {
        const serviceReservation = <ServiceReservation>(
          this.reservationPracticeFormGroup.value
        );
        this.removeServiceReservation(serviceReservation, true);
        if (serviceReservation.Entity) {
          this.reservationPracticeFormGroup.patchValue({
            Entity: serviceReservation.Entity,
          });
          await this.entitySelected(serviceReservation.Entity);
          if (serviceReservation.Plan) {
            this.reservationPracticeFormGroup.patchValue({
              Plan: serviceReservation.Plan,
            });
            await this.planSelected(serviceReservation.Plan);
          }
        }
      }
      await this.setPracticesRegionSearch(false);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    }
  }

  private refreshPracticesAditionalAndSet() {
    this.practicesRegionReservation.controls.forEach(
      (item: AbstractControl) => {
        this.refreshPracticeAditionalAndSet(item);
      },
    );

    this.refreshAditionalSet();
  }

  private refreshPracticeAditionalAndSet(item: AbstractControl) {
    this.practicesRegionReservationAux
      .filter(
        (p: PracticeRegionReservation) =>
          p.PrincipalPracticeRegionId === item.value.Id,
      )
      .forEach((pra: PracticeRegionReservation) => {
        this.addPracticeRegionAditionalReservation(pra);
      });
    this.setsSuppliesReservationAux
      .filter(
        (p: SetSuppliesReservation) =>
          p.PrincipalPracticeRegionId === item.value.Id,
      )
      .forEach((set: SetSuppliesReservation) => {
        this.addSetSuppliesReservation(set);
      });
  }

  private refreshAditionalSet() {
    this.practicesRegionAditionalReservation.getRawValue().forEach((item) => {
      if (item.Select) {
        this.setsSuppliesReservationAux
          .filter(
            (p: SetSuppliesReservation) =>
              p.PrincipalPracticeRegionId === item.Id,
          )
          .forEach((set: SetSuppliesReservation) => {
            this.addSetSuppliesReservation(set);
          });
      }
    });
  }

  enableCombo(): boolean {
    return this.reservationWizardService.EnableCombo() && !this.ocultarCombo;
  }

  onEntityChange() {
    this.clearPlan();
  }

  onPlanChange() {
    this.plan = null;
    this.conf = null;
    this.reservationWizardService.clearQuestionsAndSlotReservation();
  }

  setFocus(): void {
    if (!this.reservationPracticeFormGroup.controls.Entity.valid) {
      setTimeout(() => this.entity.nativeElement.focus(), 0);
    } else {
      setTimeout(() => this.practiceRegionReservation.nativeElement.focus(), 0);
    }
  }

  async saveServiceReservation() {
    if (
      this.reservationPracticeFormGroup &&
      this.reservationPracticeFormGroup.valid
    ) {
      const serviceReservation = new ServiceReservation(
        <ServiceReservation>this.reservationPracticeFormGroup.getRawValue(),
      );
      serviceReservation.PracticesRegionReservation = <
        PracticeRegionReservation[]
      >this.practicesRegionReservation.value;
      const practicesRegionAditionalReservations = <
        PracticeRegionReservation[]
      >this.practicesRegionAditionalReservation.getRawValue();
      const setSuppliesReservations = <SetSuppliesReservation[]>(
        this.setSuppliesReservation.getRawValue()
      );

      serviceReservation.PracticesRegionAditionalReservation = [];
      serviceReservation.SetSuppliesReservation = [];

      if (
        practicesRegionAditionalReservations &&
        practicesRegionAditionalReservations.length > 0
      ) {
        serviceReservation.PracticesRegionAditionalReservation =
          practicesRegionAditionalReservations;
      }

      if (setSuppliesReservations && setSuppliesReservations.length > 0) {
        serviceReservation.SetSuppliesReservation = setSuppliesReservations;
      }

      if (
        serviceReservation.PracticesRegionReservation != null &&
        serviceReservation.PracticesRegionReservation.length > 0
      ) {
        await this.reservationWizardService.setServiceReservationPracticeInfo(
          serviceReservation,
        );
      }
    }
  }

  async onRemoveServiceReservation(serviceReservation: ServiceReservation) {
    const createNew =
      this.reservationWizardService.getAllServiceReservations.length === 1;
    await this.removeServiceReservation(serviceReservation, createNew);
  }

  async removeServiceReservation(
    serviceReservation: ServiceReservation,
    createNew: boolean,
  ) {
    const entity = serviceReservation.Entity;
    const plan = serviceReservation.Plan;
    // elimino la reserva seleccionada
    this.reservationWizardService.removeServiceReservation(serviceReservation);

    // limpio el formulario seleccionando alguna reserva existente o genero una nueva para completar
    if (this.f.Index.value === serviceReservation.Index) {
      // tslint:disable-next-line:no-shadowed-variable
      let serviceReservation: ServiceReservation;
      if (createNew) {
        serviceReservation =
          this.reservationWizardService.getNewServiceReservation();
        serviceReservation.Entity = entity;
        serviceReservation.Plan = plan;
      } else {
        serviceReservation =
          this.reservationWizardService.getAllServiceReservations[0];
      }
      this.reservationWizardService.clearQuestionsAndSlotReservation();
      await this.setServiceReservation(serviceReservation);
    }

    this.setFocus();
  }

  async executeOnLineOperation() {
    try {
      this.loading = true;

      const info =
        await this.reservationWizardService.executeOnLineOperationInReservationPractice(
          this.selectedEntity,
          this.plan,
        );

      let isOk = true;

      if (info.NoValidate) {
        isOk = false;
        this.notificationToastService.error(
          info.Message,
          "Reserva de turno",
          true
        );
      }

      if (isOk) {
        this.notificationToastService.success(info.Message, "Reserva de turno");
      }
    } catch (err) {
      const errorDetail = err && err.error
        ? JSON.stringify(err.error)
        : (err && err.message) || "Error desconocido";
      this.notificationToastService.error(
         errorDetail,
        "Reserva de turno",
      );
    } finally {
      this.loading = false;
    }
  }

  async setInternation(isInternation: boolean) {
    this.reservationWizardService.setIsInternation(isInternation);
  }

  async entitySelected(entity: Entity) {
    this.selectedEntity = entity;
    if (entity) {
      this.plans = await this.reservationWizardService.getPlansByEntityId(
        entity.Id,
      );
      this.filterCompletePlans = new FilterCompleteService<Plan>(
        this.plans,
        this.reservationPracticeFormGroup.controls.Plan,
      );
      if (this.plans.length === 1) {
        await this.planSelected(this.plans[0]);
        this.reservationPracticeFormGroup.patchValue({ Plan: this.plans[0] });
        this.setFocus();
      }
    } else {
      this.clearPlan();
    }
  }

  async planSelected(plan: Plan) {
    try {
      this.reservationWizardService.clearQuestionsAndSlotReservation();
      this.plan = plan;
      await this.validateInNewPlanPracticesRegionIfExists();
      this.conf =
        await this.integratedAdmissionService.getIntegratedAdmissionOrderConf(
          plan.Id,
          false,
        );
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    }
  }

  // Cuando se cambia de plan valido que las practicas que estaban cargadas,
  // tambien se puedan dar con el nuevo plan
  private async validateInNewPlanPracticesRegionIfExists() {
    try {
      this.addingPractice = true;
      const practiceRegionReservations = <PracticeRegionReservation[]>(
        this.practicesRegionReservation.value
      );
      const practiceRegionSearchs: PracticeRegionSearchReservation[] = [];
      this.clearPractices();
      await this.setPracticesRegionSearch(true);
      if (this.practicesRegionSearch.length === 0) {
        this.notificationToastService.error(
          "No existe convenio para la práctica principal",
          "Reserva",
        );
      }

      if (
        practiceRegionReservations.length &&
        this.practicesRegionSearch &&
        this.practicesRegionSearch.length > 0
      ) {
        this.practicesRegionSearch.forEach(async (practiceRegionSearch) => {
          if (
            practiceRegionReservations.findIndex(
              (p) =>
                p.PracticeRegion.Id === practiceRegionSearch.PracticeRegionId,
            ) >= 0
          ) {
            practiceRegionSearchs.push(practiceRegionSearch);
          }
        });
        if (practiceRegionSearchs.length > 0) {
          await this.practicesSelected(practiceRegionSearchs);
        }
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    } finally {
      this.addingPractice = false;
    }
  }

  private async setPracticesRegionSearch(isValidatingNewPlan: boolean) {
    if (this.plan) {
      this.loadingPracticesRegion = true;
      let serviceId: number;
      const practices = <PracticeRegionReservation[]>(
        this.practicesRegionReservation.value
      );

      if (practices && practices.length > 0) {
        serviceId = practices[0].ServiceId;
      }

      this.practicesRegionSearch =
        await this.reservationWizardService.getPracticesRegionSearchReservation(
          this.plan.Id,
          this.getAddedPracticesRegionIds(isValidatingNewPlan),
          serviceId > 0 ? serviceId : null,
          null,
        );
    } else {
      this.practicesRegionSearch = [];
    }

    this.setFilterCompletePractices();
    this.loadingPracticesRegion = false;
  }

  async practicesSelected(
    practiceRegionSearchReservations: PracticeRegionSearchReservation[],
  ) {
    try {
      this.addingPractice = true;
      const practiceRegionIds: number[] = [];
      practiceRegionSearchReservations.forEach(
        (practiceRegionSearchReservation) => {
          practiceRegionIds.push(
            practiceRegionSearchReservation.PracticeRegionId,
          );
        },
      );

      // busco los set de insumo y adiciones que le corresponden a la practica agregada
      const principalsSetAndAditionals =
        await this.reservationWizardService.getAditionalPracticeAndSetSuppliesReservation(
          practiceRegionIds,
          this.plan.Id,
          null,
        );

      principalsSetAndAditionals.forEach((principalSetAndAditionals) => {
        const index = practiceRegionSearchReservations.findIndex(
          (p) =>
            p.PracticeRegionId ===
            principalSetAndAditionals.PracticeRegionReservation.PracticeRegion
              .Id,
        );
        const practiceRegionSearchReservation =
          practiceRegionSearchReservations[index];
        if (index > -1) {
          this.addPracticeRegionReservation(
            principalSetAndAditionals.PracticeRegionReservation,
          );
          this.reservationPracticeFormGroup.patchValue({
            PracticeRegionReservation: null,
          });

          if (
            principalSetAndAditionals.SetsSuppliesReservation &&
            principalSetAndAditionals.SetsSuppliesReservation.length > 0
          ) {
            principalSetAndAditionals.SetsSuppliesReservation.forEach(
              (item: SetSuppliesReservation) => {
                this.setsSuppliesReservationAux.push(item);
                if (
                  item.PrincipalPracticeRegionId ===
                  practiceRegionSearchReservation.PracticeRegionId
                ) {
                  this.addSetSuppliesReservation(item);
                }
              },
            );
          }

          if (
            principalSetAndAditionals.PracticesRegionReservation &&
            principalSetAndAditionals.PracticesRegionReservation.length > 0
          ) {
            principalSetAndAditionals.PracticesRegionReservation.forEach(
              (item: PracticeRegionReservation) => {
                this.practicesRegionReservationAux.push(item);
                this.addPracticeRegionAditionalReservation(item);
              },
            );
          }

          this.refreshAditionalSet();
        }
      });

      this.reservationWizardService.clearQuestionsAndSlotReservation();
      await this.setPracticesRegionSearch(false);

      this.setFocus();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    } finally {
      this.addingPractice = false;
    }
  }

  async practiceSelected(
    practiceRegionSearchReservation: PracticeRegionSearchReservation,
  ) {
    try {
      const practiceRegionSearchReservations: PracticeRegionSearchReservation[] =
        [];
      practiceRegionSearchReservations.push(practiceRegionSearchReservation);
      await this.practicesSelected(practiceRegionSearchReservations);
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.entities = await this.reservationWizardService.getEntities();
      this.filterCompleteEntities = new FilterCompleteService<Entity>(
        this.entities,
        this.reservationPracticeFormGroup.controls.Entity,
      );
      // muestro la primer reserva agregada
      const serviceReservation =
        this.reservationWizardService.getServiceReservation(0);

      if (serviceReservation.PracticeRegionReservation != null) {
        await this.setServiceReservationFromSchedul(serviceReservation);
      } else {
        await this.setServiceReservation(serviceReservation);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    } finally {
      this.loading = false;
      this.isInit = true;
    }
  }

  private setFilterCompletePractices() {
    if (this.practicesRegionSearch && this.practicesRegionSearch.length > 0) {
      this.filterCompletePractices =
        this.f.PracticeRegionReservation.valueChanges.pipe(
          startWith<string | PracticeRegionSearchReservation>(""),
          map((value) =>
            typeof value === "string" ? value : value ? value.SeachText : "",
          ),
          map((name) => this.filterPracticeRegionSearch(name)),
        );
    } else {
      this.filterCompletePractices = new Observable<
        PracticeRegionSearchReservation[]
      >();
    }
  }

  // agrego un nuevo servicio
  async getNewServiceReservation() {
    if (
      this.reservationPracticeFormGroup &&
      this.reservationPracticeFormGroup.valid
    ) {
      await this.saveServiceReservation();
      const serviceReservation =
        this.reservationWizardService.getNewServiceReservation();
      await this.setServiceReservation(serviceReservation);
      this.reservationWizardService.clearQuestionsAndSlotReservation();
      this.setFocus();
    }
  }

  async setServiceReservationFromSchedul(
    serviceReservation: ServiceReservation,
  ) {
    await this.setServiceReservationOrder(serviceReservation);

    await this.practicesSelected(
      serviceReservation.PracticesRegionReservation.map((item) => {
        const prr = new PracticeRegionSearchReservation();
        prr.Id = item.Id;
        prr.Name = item.Name;
        prr.PracticeRegionId = item.PracticeRegion.Id;
        prr.PracticeRegionName = item.PracticeRegion.Name;
        prr.Quantity = item.Quantity;
        prr.ServiceId = item.ServiceId;
        return prr;
      }),
    );

    if (
      serviceReservation.PracticesRegionAditionalReservation &&
      serviceReservation.PracticesRegionAditionalReservation.length > 0
    ) {
      serviceReservation.PracticesRegionAditionalReservation.forEach(
        (item: PracticeRegionReservation) => {
          // busco si la practica se encuentra cargada
          let index = (<PracticeRegionReservation[]>(
            this.practicesRegionAditionalReservation.getRawValue()
          )).findIndex((x) => x.PracticeRegion.Id === item.PracticeRegion.Id);

          if (index > -1) {
            const quantity = item.Quantity;
            const exists = (<PracticeRegionReservation[]>(
              this.practicesRegionAditionalReservation.getRawValue()
            ))[index];
            exists.Quantity = quantity;
            exists.Select = true;
            this.practicesRegionAditionalReservation.removeAt(index);
            this.addPracticeRegionAditionalReservation(exists);
            this.practiceRegionAditionalReservationCheckChange(
              this.practicesRegionAditionalReservation.length - 1,
            );
          }
        },
      );
    }

    if (
      serviceReservation.SetSuppliesReservation &&
      serviceReservation.SetSuppliesReservation.length > 0
    ) {
      serviceReservation.SetSuppliesReservation.forEach(
        (item: SetSuppliesReservation) => {
          // busco si el set de insumo se encuentra cargado
          const index = (<SetSuppliesReservation[]>(
            this.setSuppliesReservation.value
          )).findIndex((x) => x.Id === item.Id);
          if (index > -1) {
            const quantity = item.Quantity;
            const exists = (<SetSuppliesReservation[]>(
              this.setSuppliesReservation.getRawValue()
            ))[index];
            exists.Quantity = quantity;
            exists.Select = true;
            this.setSuppliesReservation.removeAt(index);
            this.addSetSuppliesReservation(exists);
          }
        },
      );
    }

    await this.setPracticesRegionSearch(false);
  }

  // cargo los datos en el formulario
  async setServiceReservation(serviceReservation: ServiceReservation) {
    await this.setServiceReservationOrder(serviceReservation);

    if (
      serviceReservation.PracticesRegionAditionalReservation &&
      serviceReservation.PracticesRegionAditionalReservation.length > 0
    ) {
      serviceReservation.PracticesRegionAditionalReservation.forEach(
        (item: PracticeRegionReservation) => {
          this.addPracticeRegionAditionalReservation(item);
        },
      );
    }

    if (
      serviceReservation.SetSuppliesReservation &&
      serviceReservation.SetSuppliesReservation.length > 0
    ) {
      serviceReservation.SetSuppliesReservation.forEach(
        (item: SetSuppliesReservation) => {
          this.addSetSuppliesReservation(item);
        },
      );
    }

    await this.setPracticesRegionSearch(false);
  }

  private async setServiceReservationOrder(
    serviceReservation: ServiceReservation,
  ) {
    this.reservationPracticeFormGroup.controls.PracticesRegionReservation =
      this.formBuilder.array([]);
    this.reservationPracticeFormGroup.controls.PracticesRegionAditionalReservation =
      this.formBuilder.array([]);
    this.reservationPracticeFormGroup.controls.SetSuppliesReservation =
      this.formBuilder.array([]);
    this.practicesRegionSearch = [];

    if (serviceReservation.Entity != null && serviceReservation.Entity.Id > 0) {
      await this.entitySelected(serviceReservation.Entity);
    }

    this.plan = serviceReservation.Plan;

    this.reservationPracticeFormGroup.patchValue({
      Index: serviceReservation.Index,
      Center: serviceReservation.Center,
      Entity: serviceReservation.Entity,
      Plan: serviceReservation.Plan,
      PracticeRegionReservation: null,
      DateOrder: serviceReservation.DateOrder,
      Diagnostic: serviceReservation.Diagnostic,
      ReferringPhysician: serviceReservation.ReferringPhysician,
      Observation: serviceReservation.Observation,
      PatientObservation: serviceReservation.PatientObservation,
      CredentialNumber: serviceReservation.CredentialNumber,
      SecurityCodeCredentialNumber:
        serviceReservation.SecurityCodeCredentialNumber,
      ReservationSlot: serviceReservation.ReservationSlot,
      MedicalAppointmentOriginalId:
        serviceReservation.MedicalAppointmentOriginalId,
      ReAppointmentDuration: serviceReservation.ReAppointmentDuration,
    });

    if (
      serviceReservation.PracticesRegionReservation &&
      serviceReservation.PracticesRegionReservation.length > 0
    ) {
      serviceReservation.PracticesRegionReservation.forEach(
        (item: PracticeRegionReservation) => {
          this.addPracticeRegionReservation(item);
        },
      );
    }
  }

  async openPreparationDialog() {
    await this.saveServiceReservation();
    const dialogRef = this.dialog.open(
      PracticeRegionPreparationDialogComponent,
      {
        width: "70%",
        data: this.reservationWizardService.allPracticesAndAditionalIds,
      },
    );
  }

  // muestro los datos de la reserva seleccionada
  async loadServiceReservation(index: number) {
    try {
      this.loadingReservationService = true;
      this.saveServiceReservation();
      await this.setServiceReservation(
        this.reservationWizardService.getServiceReservation(index),
      );
      this.setFocus();
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), "Reserva");
    } finally {
      this.loadingReservationService = false;
    }
  }

  async save() {
    if (this.completed) {
      await this.saveServiceReservation();
    }
  }
}
